// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectionListItemContent__nwOqslidqf{gap:var(--dixa-size-spacer-200)}`, "",{"version":3,"sources":["webpack://./src/components/hookForm/hookFormUserSelect/hookFormUserSelect.module.scss"],"names":[],"mappings":"AAAA,sCACE,+BAAA","sourcesContent":[".selectionListItemContent {\n  gap: var(--dixa-size-spacer-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectionListItemContent": `selectionListItemContent__nwOqslidqf`
};
export default ___CSS_LOADER_EXPORT___;
